var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLab(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.16671 12.8334C0.939603 12.8334 0.733077 12.7016 0.637493 12.4956C0.541936 12.2896 0.574662 12.0469 0.721233 11.8735L5.18809 6.51867L5.18809 2.33337C4.86592 2.33337 4.60475 2.0722 4.60475 1.75004C4.60475 1.42787 4.86592 1.1667 5.18809 1.1667L8.80182 1.1667C9.12398 1.1667 9.38515 1.42787 9.38515 1.75004C9.38515 2.0722 9.12398 2.33337 8.80182 2.33337L8.7945 2.33337L8.7945 6.51867L13.2789 11.8735C13.4254 12.0469 13.4581 12.2896 13.3626 12.4956C13.267 12.7016 13.0605 12.8334 12.8334 12.8334L1.16671 12.8334ZM7.76569 7.10827C7.67669 7.00299 7.62784 6.86959 7.62783 6.73173L7.62783 2.33337L6.35475 2.33337L6.35475 6.73173C6.35475 6.86959 6.3059 7.00299 6.2169 7.10827L2.42395 11.6667L11.5761 11.6667L7.76569 7.10827Z",
    fill: "#C11E05"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLab);
export default __webpack_public_path__ + "static/media/lab.0f209a355d46024d1d9bad363a569398.svg";
export { ForwardRef as ReactComponent };